import { render } from "./PContentModel.vue?vue&type=template&id=36c18348&scoped=true"
const script = {}

import "./PContentModel.vue?vue&type=style&index=0&id=36c18348&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c18348"]])

export default __exports__